import { ISetSortPayload } from 'PyzShopUi/scripts/shop-ui/components/search-page/actions/sort';
import { PARAM_PAGE, PARAM_SORT } from 'PyzShopUi/scripts/shop-ui/components/search-page/constants';
import { IApiQueryData, IProductReviewActionState } from 'PyzShopUi/scripts/product-review/interfaces';

export const doSetSort = (state: IProductReviewActionState, payload: ISetSortPayload): IProductReviewActionState => {
    const newApiQueryData: IApiQueryData = {
        ...state.apiQueryData,
        [PARAM_SORT]: payload.sort,
        [PARAM_PAGE]: '1',
    };

    return {
        ...state,
        productReviews: [],
        isPageLoading: true,
        apiQueryData: newApiQueryData,
    };
};
